import React from 'react';
import classNames from 'classnames';
import * as styles from './checkbox.module.sass';
import { CheckboxProps } from './props.type';
import { FieldWrapper } from '../FieldWrapper/FieldWrapper';
import { useField } from 'formik';
import { Size } from '../../enums/size';

export const Checkbox = (props: CheckboxProps) => {
  const { name, label = '', className = '', disabled = false, hint } = props;
  const { wrapper, checkbox, checkbox_label } = styles;
  const [field, meta, helpers] = useField(name);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {  
    helpers.setTouched(true, true);
    helpers.setValue(event.target.checked);
  };

  

  return (
    <FieldWrapper size={props.size ? props.size : Size.MEDIUM} hint={hint} errors={props.isFocused ? meta.error : ''} className={className}>
      <label className={classNames(wrapper)}>
        <input
          onChange={onChangeHandler}
          disabled={disabled}
          name={name}          
          className={classNames(checkbox, { disabled })}
          
          type="checkbox"
          checked={field.value}          
        />

        <span className={classNames(checkbox_label, { disabled }, props.spanClassName)}>{label}</span>
      </label>
    </FieldWrapper>
  );
};
